import { PlatformRequestUser, UserOrganizationStatus } from '@markant-platform/shared/user/model';
import { SalutationType } from 'data-model';

export const MOCK_PLATFORM_USERS: PlatformRequestUser[] = [
  {
    id: '66ded00f9e41d2ad6590b50d',
    salutation: SalutationType.m,
    firstname: 'Sabino',
    lastname: 'Rui',
    email: 'sabino.rui@byom.de',
    organizationMembershipStatus: UserOrganizationStatus.INVITED,
  },
  {
    id: '66ded0b19e41d2ad6590b50e',
    salutation: SalutationType.m,
    firstname: 'Jorge',
    lastname: 'Abel',
    email: 'jorge.abel@byom.de',
    organizationMembershipStatus: UserOrganizationStatus.INVITED,
  },
  {
    id: '66ded0d39e41d2ad6590b50f',
    salutation: SalutationType.w,
    firstname: 'Maria',
    lastname: 'Ana',
    email: 'maria.ana@byom.de',
    organizationMembershipStatus: UserOrganizationStatus.ACTIVE,
  },
  {
    id: '66ded1351ce4f9a6e21cca64',
    salutation: SalutationType.w,
    firstname: 'Jessica',
    lastname: 'Beatriz',
    email: 'jessica.beatriz@byom.de',
    organizationMembershipStatus: UserOrganizationStatus.INVITED,
  },
];
